// src/config/brand.ts
export const brandConfig = {
  logo: "/assets/logos/logo.png",
  mainBox: "/assets/boxes/box1.png",

  title: "HARKAN CASES",
  subtitle: {
    pre: "OPEN AND",
    highlight: "WIN UP TO 219.889 ASTR",
  },

  colors: {
    accent: "#9EC3FF",
    gradient:
      "linear-gradient(95.66deg, rgba(255, 255, 255, 0.8) 35.36%, #E6007A 45%, #FFFFFF 68.58%, rgba(48, 48, 48, 0) 128.34%)",
    button: "#FFD700",
    secondary:
      "linear-gradient(276.04deg, rgba(28, 28, 28, 0.02) -90.31%, rgba(159, 159, 159, 0.584318) -14.46%, #51A2FF 18.77%, #FFFFFF 60.25%, rgba(48, 48, 48, 0) 165.35%)",
    subtitle:
      "linear-gradient(96.04deg, rgba(28, 28, 28, 0.02) -65.35%, rgba(159, 159, 159, 0.584318) 10.49%, #51A2FF 43.73%, #FFFFFF 85.2%, rgba(48, 48, 48, 0) 190.31%)",
  },
};
